<template>
    <div class="reports p-20">
        <AdminTable v-if="loaded"
            class="margin-center main-table"
            header='Reporst List' 
            subheader="List of generated reports for this account"
            :headers="[
                { key: 'entiry_referance', name: 'Referance Number' , format: (val) => val ? val : 'N/A', type: 'file-xml'},
                { key: 'originalDate', name: 'Transaction Date', format: (val) => val ? Utils.renderTime(val) : 'N/A' },
                { key: 'date', name: 'Generated At', format: (val) => val ? Utils.renderTime(val) : 'N/A' },
            ]"
            :data="reportList"
            @row-click="handleRowClick"
        />
        <vue-awesome-paginate
            v-if="totalCount > 10"
            class="pagination"
            :total-items="totalCount"
            :items-per-page="10"
            :max-pages-shown="8"
            v-model="currentPage"
            @click="handlePageClick"
        />

        <PopupCover v-if="selectedReport" @close="selectedReport = null">
            <PopupBody style="width: 1000px;" @close="selectedReport = null">
                <template #header>
                    <div class="flex justify-between items-center gap-20px w-full">    
                        {{ `Report Details - ${selectedReport?.entiry_referance}` }}
                        <button class='button w-content' @click="downloadReport"> Download</button>
                    </div>
                </template>
                <template #body>
                    <div class="report-content" style="white-space: pre-wrap;"
                    >
                    <pre><code class="language-xml">{{selectedReport.xmlReport}}</code></pre>
                    </div>
                </template>
            </PopupBody>

        </PopupCover>
    </div>
</template>

<script setup>
    import { ref, onMounted,  } from 'vue';
    import API from '../api/index';
    import AdminTable from '@/components/AdminTable.vue';
    import Utils from '@/utils';
    import PopupCover from '@/components/PopupCover.vue';
    import PopupBody from '@/components/PopupBody.vue';

    import hljs from 'highlight.js';
    import 'highlight.js/styles/github.css'; // pick a theme


    const selectedReport = ref(null);
    const reportList = ref(null);
    const totalCount = ref(null);
    const currentPage = ref(1);
    const loaded = ref(false);
    const props = defineProps(['account_id'])

    onMounted(async () => {
        document.title = 'Reports';
        await doRequest();
    })

    function handleRowClick(row) {
        console.log('row clicked: ', row);
        selectedReport.value = row;
        setTimeout(() => {
                hljs.highlightAll();
        }, 100)
    }
    const handlePageClick = async (page) => {
        currentPage.value = page;
        await doRequest();
    }
    async function doRequest() {
        const result = await API.getReportList(props.account_id, currentPage.value);
        loaded.value = true;
        console.log('report list result: ', result);
        reportList.value = result.response_data.map((item) => {
            return {
                ...item,
                template_type: item?.template_data?.label,
                filename: item?.file?.filename,
            }
        });
        totalCount.value = result.totalCount;

    }
    async function downloadReport() {
        if(!selectedReport.value) return;
        const url = window.URL.createObjectURL(new Blob([selectedReport.value.xmlReport]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${selectedReport.value.entiry_referance}.xml`);
        document.body.appendChild(link);
        link.click();
    }


</script>

<style scoped lang="scss">
    .report-content {
        max-height: 85vh;
        overflow-y: auto;
        text-align: left;
        border: 1px solid var(--border-color);
        border-radius: 10px;
        box-sizing: border-box;
        background-color: white;
        line-height: 1.1;
    }
    .pagination[class] {
        margin: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
    
        &:deep(button) {
            padding: 10px 20px;
        }
        &:deep(.active-page) {
            background: #00408985;
            color: white;
        }
    }
    .main-table {
        &:deep(.table-list td) {
            padding-top: 0;
            padding-bottom: 0;
        }
    }
</style>